<template>
    <div class="map">
        <div class="map-container">
            <img v-if="isMobile" src="/images/map-m.png">
            <img v-else src="/images/map.png">
            <div class="branches-wrapper">
                <button v-for="(branche, brancheIndex) in branches"
                        class="branche-location"
                        :class="branche.name"
                        @mouseover="showCard(branche.name)"
                        @click="changeBranche(brancheIndex)"
                >
                    <img v-show="branches[currentBranche].name==branche.name" src="/images/map-full.png">
                    <img v-show="branches[currentBranche].name!=branche.name" src="/images/map-empty.png">

                    <div
                         class="branche-infos"
                         @mouseleave="displayCard=false"
                         v-if="branches[currentBranche].name==branche.name && displayCard && !isMobile"
                    >
                        <!--v-for="(branche, brancheIndex) in branches"-->
                        <h3>{{ branche.title }}</h3>
                        <p>
                            <img src="/images/map-pin.png" alt="">
                            <a target="_blank" :href="'http://maps.google.com/?q='+branche.address">{{ branche.address }}</a>
                        </p>
                        <p>
                            <img src="/images/phone.png" alt="">
                            <a  :href="'tel:'+branche.phone">{{ branche.phone }}</a>
                        </p>
                        <p>
                            <img src="/images/mail.png" alt="">
                            <a :href="'mailto:' + branche.mail">{{ branche.mail }}</a>
                        </p>
                    </div>
                </button>
                <carousel :items-to-show="1" :wrapAround="true" v-if="isMobile" class="branches-infos-carousel" v-model="currentBranche">
                    <slide v-for="(branche, brancheIndex) in branches" :key="'branche'+branche.name" >
                            <div class="branche-content" >
                                <h3>{{branche.title}}</h3>
                                <div><img src="/images/map-pin.png" alt=""><span>{{ branche.address }}</span></div>
                                <div><img src="/images/phone.png" alt=""><span>{{ branche.phone }}</span></div>
                                <div><img src="/images/mail.png" alt=""><span>{{ branche.mail }}</span></div>
                            </div>
                    </slide>
                    <template #addons>
                        <pagination />
                    </template>
                </carousel>
            </div>
        </div>
    </div>
</template>

<script>
import width from "../../helpers/width";
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
export default {
    mixins: [width],
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },
    data() {
        return {
            displayCard: true,
            // currentBranche: 'brussels',
            currentBranche: 0,
            branches: [
                {
                    name: 'london',
                    title: this.$t('message.contact.map_london'),
                    address: 'Berkeley Square House, 8th Floor, Berkeley Square',
                    phone: '+44 20 7518 8100',
                    mail: 'information@bbe.digital'
                },
                {
                    name: 'brussels',
                    title: this.$t('message.contact.map_brussels'),
                    address: 'Bld Bischoffsheim 1/8, 1000 Bruxelles',
                    phone: '+32 (0) 2 551 00 20',
                    mail: 'information@bbe.digital'
                },
                {
                    name: 'paris',
                    title: this.$t('message.contact.map_paris'),
                    address: '120 Avenue des Champs-Elysées',
                    phone: '+33 1 45 63 10 01',
                    mail: 'information@bbe.digital'
                }
            ]
        }
    },
    methods: {
        changeBranche(branche) {
            this.currentBranche = branche;
            // this.$emit('brancheChanged', _.find(this.branches, (b) => {
            //     return this.branches[branche].name == b.name
            // }).mail);
            this.$emit('brancheChanged',this.branches[branche].mail)
        },
        showCard(name) {
            this.branches[this.currentBranche].name == name ? this.displayCard = true : null;
        }
    }
}
</script>

<style scoped>

</style>
